import React from 'react'

export const SiteHeader = () => {
  return <div></div>
}
